import { render } from "./scheduleTag.vue?vue&type=template&id=3f770dc6"
import script from "./scheduleTag.vue?vue&type=script&lang=js"
export * from "./scheduleTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__